// extracted by mini-css-extract-plugin
export default {"free":"free-YYZg"};